module.exports = __webpack_public_path__ + "img/sumary_total_expense.05b6c13b.svg";